
import './DeleteInputFormsForAnswerTrouble.scss';
import { closeDeleteInputFormsForTrouble } from '../troubleslice';

const DeleteInputFormsForTrouble  = (props) => {
const {dispatch} = props;
  
 // CLICK OK
const onSend = () => {

        props.handleDeleteTrouble();
}


// CLOSE FORM
const onClose = () => {
   
    dispatch(closeDeleteInputFormsForTrouble());

}


   
        return (
        
        
            
                <div className="DeleteInputFormsForAnswerTrouble">

                    <p>Вы действительно хотите удалить вопрос со всеми ответами к нему?</p>
                    <div className='row-block'>
                        <button onClick={onSend}>Да</button>
                        <button onClick={onClose}>Отмена</button>
                    </div>
                    
                </div>
        
        
        
        
        )
       
    
}
export default DeleteInputFormsForTrouble;